import { useMemo } from 'react';
import { COMMENT_SUMMARY_TYPE, REMOTE_ISSUE_LINKS_TYPE } from '@atlassian/jira-business-constants';
import {
	useIssueTypesAndFields,
	type BusinessIssueField,
} from '@atlassian/jira-business-entity-project';

export const useSystemFields = () => {
	const { data } = useIssueTypesAndFields({ issueOperation: 'VIEW' });

	const globalSystemFields = useMemo(() => {
		const issueTypesAndFieldsData: BusinessIssueField[] = data ? data?.fields : [];

		return issueTypesAndFieldsData
			.filter((field) => !field.id.startsWith('customfield'))
			.map((field) => field.id)
			.concat('key', COMMENT_SUMMARY_TYPE, REMOTE_ISSUE_LINKS_TYPE);
	}, [data]);

	return { globalSystemFields };
};
